import React from "react";
import Admin from "./layout/Admin";
import Auth from "./layout/Auth";
import Push from "push.js";
import Detector from "./components/ConnectionDetector";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
// import { useAuth } from "./context/AuthContext";

function App() {
  // const { user } = useAuth();
  React.useEffect(() => {
    if (!Push.Permission.has() || Push.Permission.get() !== "granted") {
      Push.Permission.request(onGranted, onDenied);
      Push.Permission.get();
    }
  }, []);

  const onGranted = () => { };
  const onDenied = () => { };

  // console.log(user?.employee?.employee_id);

  return (
    <>
      <Detector />
      <Router>
        <Switch>
          <Route path="/admin" render={(props) => <Admin {...props} />} />
          <Route path="/auth" render={(props) => <Auth {...props} />} />
          <Redirect from="/" to="/auth" />
        </Switch>
      </Router>
    </>
  );
}

export default App;
